import { render } from "./AlreadyHaveTrailerAttached.vue?vue&type=template&id=4c892cfc&ts=true"
import script from "./AlreadyHaveTrailerAttached.vue?vue&type=script&lang=ts"
export * from "./AlreadyHaveTrailerAttached.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__